export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://localhost:5119/api',
  GATEWAY_URL: import.meta.env.VITE_GATEWAY_URL || 'http://localhost:5119',
  TIMEOUT: 30000,
} as const;

export const AUTH_CONFIG = {
  TOKEN_KEY: 'authToken',
  USER_KEY: 'kyc_user',
  ROLE_KEY: 'userRole',
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
} as const;

export const PAGINATION_CONFIG = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
} as const;

export const USER_ROLES = {
  ADMIN: 'Administrator',
  ADVANCED: 'AdvancedUser',
  USER: 'User',
  NO_ACCESS: 'NoAccess',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const ACCOUNT_STATUSES = [
  { id: 'Active', name: 'Active' },
  { id: 'Limited', name: 'Limited' },
  { id: 'Blocked', name: 'Blocked' },
];

export const LOGGING_STATUSES = [
  { id: 'None', name: 'None' },
  { id: 'Wrong', name: 'Wrong' },
  { id: 'All', name: 'All' },
];

/** Maps for converting string enum values to backend integer values */
export const ACCOUNT_STATUS_TO_INT: Record<string, number> = { Active: 1, Limited: 2, Blocked: 3 };
export const LOGGING_STATUS_TO_INT: Record<string, number> = { None: 1, Wrong: 2, All: 3, '0': 1, '1': 1, '2': 2, '3': 3 };
export const USER_ROLE_TO_INT: Record<string, number> = { Administrator: 1, AdvancedUser: 2, User: 3, NoAccess: 4 };
export const INT_TO_USER_ROLE: Record<number, string> = { 1: 'Administrator', 2: 'AdvancedUser', 3: 'User', 4: 'NoAccess' };

export const DOCUMENT_SIDES = [
  { id: 'Front', name: 'Front' },
  { id: 'Back', name: 'Back' },
  { id: 'Both', name: 'Both' },
];

export const DOCUMENT_SIDE_TO_INT: Record<string, number> = { Front: 1, Back: 2, Both: 3 };

export const USER_ROLE_CHOICES = [
  { id: 'Administrator', name: 'Administrator' },
  { id: 'AdvancedUser', name: 'Advanced User' },
  { id: 'User', name: 'User' },
  { id: 'NoAccess', name: 'No Access' },
];

export const OPERATION_TYPES = [
  { id: 0, name: 'KycSingleSide', defaultCredits: 1 },
  { id: 1, name: 'KycDualSide', defaultCredits: 1.5 },
  { id: 2, name: 'MrzSingleSide', defaultCredits: 0.5 },
  { id: 3, name: 'MrzDualSide', defaultCredits: 0.8 },
];

/* ── OCR Testing constants ── */

export const OCR_OPERATION_TYPES = [
  { id: 1, name: 'KycSingleSide' },
  { id: 2, name: 'KycDualSide' },
  { id: 3, name: 'MrzSingleSide' },
  { id: 4, name: 'MrzDualSide' },
  { id: 5, name: 'QrMidni' },
  { id: 6, name: 'FaceCompare' },
] as const;




/** Operations that require dual-side images */
export const OCR_DUAL_SIDE_OPERATIONS = [2, 4];
